<template>
    <div v-if="!loading">
        <h2 class="site-title">{{ $t('orders.view', { number: order.number }) }}</h2>
        <table class="customer-table">
            <tr>
                <td align="center">
                    <customer :customer="order.customer"></customer>
                </td>
                <td align="center">
                    <order-pdf
                        :id="order.id"
                        :number="order.number"
                        @downloading="downloading = true"
                        @finished="downloading = false"
                        v-slot:activator="{ activate }">
                        <v-btn
                            large
                            color="deep-orange"
                            :loading="downloading"
                            dark
                            v-on="activate">
                            <v-icon color="white">
                                mdi-file-pdf-box
                            </v-icon>
                        </v-btn>
                    </order-pdf>
                </td>
            </tr>
        </table>
        <order-items :list="order.items"></order-items>
        <div style="max-width:800px; margin: 0 auto;">
            <project :terraces="order.terraces"></project>
        </div>
    </div>
</template>

<script>
    import Items from './Items'
    import Customer from './Customer'
    import Project from './Project';
    import Pdf from './Pdf'

    export default {
        components: { 'order-items': Items, Customer, Project, 'order-pdf': Pdf },
        name: "OrderView",
        data() {
            return {
                loading: true,
                order: null,
                downloading : false
            }
        },
        mounted() {
            this.loading = true
            this.$http.get('/orders/' + this.$route.params.id)
                .then(({ data }) => {
                    this.order = data
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                })
        }
    }
</script>

<style scoped>
    .customer-table {
        width: 700px;
    }
    .customer-table td {
        width: 50%;
    }
</style>
